export const resourceTypes = {
    kycDocument: 'kyc-document',
    invoice: 'invoice',
    transaction: 'transaction',
    subscription: 'subscription',
    creditMemo: 'credit-memo',
    coupon: 'coupon',
};

export default {
    resourceTypes,
};
